/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function CreateUserRequestFromJSON(json) {
    return CreateUserRequestFromJSONTyped(json, false);
}
export function CreateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: !exists(json, 'name') ? undefined : json['name'],
        email: !exists(json, 'email') ? undefined : json['email'],
        password: !exists(json, 'password') ? undefined : json['password'],
        firstName: !exists(json, 'firstName') ? undefined : json['firstName'],
        lastName: !exists(json, 'lastName') ? undefined : json['lastName'],
    };
}
export function CreateUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        email: value.email,
        password: value.password,
        firstName: value.firstName,
        lastName: value.lastName,
    };
}
